import { Phone, Mail, MapPinned, Linkedin, FileText } from "lucide-react";
import { SERVICES, COMPANY } from "../../data/siteData";

const LOGO = "https://customer-assets.emergentagent.com/job_telecom-rigging/artifacts/9ue13u4p_Original%20on%20Transparent.png";

const scrollTo = (e, href) => {
  e.preventDefault();
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Footer = ({ content }) => {
  const contact = content?.contact || {
    phone: "0487 096 279",
    email: "admin@quanticom.com.au",
    address_line1: "Wollert",
    address_line2: "3750",
  };
  const services = content?.services?.length ? content.services : SERVICES;
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#050F22] border-t border-white/10 pt-20 pb-10" data-testid="footer">
      <div className="container-custom">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-14">
          <div>
            <img src={LOGO} alt="Quanticom" className="h-16 w-auto brightness-0 invert mb-5" />
            <p className="text-slate-400 text-sm leading-relaxed max-w-xs mb-5">
              Delivering tower rigging, wireless infrastructure, fibre networks and maintenance services across Australia.
            </p>
            <ul className="space-y-1.5 text-sm text-slate-400">
              <li><span className="text-slate-500">ABN</span> {COMPANY.abn}</li>
              <li><span className="text-slate-500">ACN</span> {COMPANY.acn}</li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Services</h4>
            <ul className="space-y-2.5">
              {services.slice(0, 5).map((s, i) => (
                <li key={i}>
                  <a href="#services" onClick={(e) => scrollTo(e, "#services")} className="text-sm text-slate-400 hover:text-[#00D4FF] transition-colors">
                    {s.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2.5">
              {[["Industry Experience", "#experience"], ["How We Deliver", "#process"], ["Coverage", "#coverage"], ["Team", "#team"], ["Contact", "#contact"]].map(([label, href]) => (
                <li key={href}>
                  <a href={href} onClick={(e) => scrollTo(e, href)} className="text-sm text-slate-400 hover:text-[#00D4FF] transition-colors">{label}</a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2.5 text-sm text-slate-400">
                <Phone className="w-4 h-4 text-[#00D4FF]" />
                <a href={`tel:${contact.phone?.replace(/\s/g, "")}`} className="hover:text-[#00D4FF] transition-colors">{contact.phone}</a>
              </li>
              <li className="flex items-center gap-2.5 text-sm text-slate-400">
                <Mail className="w-4 h-4 text-[#00D4FF]" />
                <a href={`mailto:${contact.email}`} className="hover:text-[#00D4FF] transition-colors break-all">{contact.email}</a>
              </li>
              <li className="flex items-start gap-2.5 text-sm text-slate-400">
                <MapPinned className="w-4 h-4 text-[#00D4FF] mt-0.5" />
                <span>{contact.address_line1}, {contact.address_line2}</span>
              </li>
              <li className="flex items-start gap-2.5 text-sm text-slate-400">
                <FileText className="w-4 h-4 text-[#00D4FF] mt-0.5" />
                <span><span className="text-slate-500">Service Areas:</span> {COMPANY.serviceAreas}</span>
              </li>
              <li>
                <a href={COMPANY.linkedin} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-[#00D4FF] transition-colors">
                  <Linkedin className="w-4 h-4" /> LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">© {year} Quanticom Pty Ltd. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <span className="text-slate-500 hover:text-[#00D4FF] text-sm transition-colors cursor-pointer">Privacy Policy</span>
            <span className="text-slate-500 hover:text-[#00D4FF] text-sm transition-colors cursor-pointer">Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
